import { type FC } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { t } from 'i18next';

import { ENV } from '@/common/app/env';
import { AppRoute } from '@/common/app/routes';
import { toggleOpenPresentation } from '@/redux/reducers/modalsReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { Assistant } from '../ui/Assistant/Assistant';

const ReadMeTool: FC = () => {
  const userLevel = useAppSelector((state) => state.user.user?.level);
  const location = useLocation();
  const dispatch = useAppDispatch();

  const isVisible = !!matchPath(AppRoute.MAIN, location.pathname);
  const helpIconIsVisible = (userLevel || 0) < ENV.MIN_LEVEL_FOR_HELPICON;

  return (
    helpIconIsVisible &&
    isVisible && (
      <Assistant
        onClick={() => dispatch(toggleOpenPresentation())}
        className="pointer-events-auto"
        label={t('Tutorial')}
      />
    )
  );
};

export { ReadMeTool };
